import { Timestamp } from 'firebase/firestore';

const pad = (value: number) => String(value).padStart(2, '0');

/**
 * Returns the calendar day represented by a Date in the user's local timezone.
 * Time log document IDs use this format and must not be derived with
 * toISOString(), which represents the UTC calendar day instead.
 */
export const toDayKey = (date: Date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

/** Creates the canonical midnight-UTC timestamp stored on a day document. */
export const dayKeyToTimestamp = (dayKey: string) => {
  const [year, month, day] = dayKey.split('-').map(Number);
  return Timestamp.fromDate(new Date(Date.UTC(year, month - 1, day)));
};
